import RenderGenderRadio from './RenderGenderRadio'

export default RenderGenderRadio
